import React from "react";
import ReactDOM from "react-dom";

export class Portal extends React.PureComponent<React.PropsWithChildren> {
	private el = document.createElement("div");

	componentDidMount(): void {
		const container = this.findContainer();
		container.appendChild(this.el);
	}

	componentWillUnmount(): void {
		const container = this.findContainer();
		container.removeChild(this.el);
	}

	render(): React.ReactNode {
		return ReactDOM.createPortal(this.props.children, this.el);
	}

	private findContainer(): HTMLDivElement {
		const container = document.querySelector<HTMLDivElement>("#app");
		if (container === null) {
			throw new Error("portal container not found");
		}
		return container;
	}
}
